<template>
  <div>
    <div class="flex-just res">
      <div class="card">
        <h1>{{translation.label_total_leads}}</h1>
        <div>
          <div class="flex-just">
            <h2>{{translation.label_total_tier_leads}}</h2>
            <h2>{{generalInfos.total_leads}}</h2>
          </div>
          <hr>
          <div class="flex-just">
            <h2>{{translation.label_2_total_tier_leads}}</h2>
            <h2>{{generalInfos.usuarios_2tier}}</h2>
          </div>
        </div>
      </div>
      <div class="card">
        <h1>{{translation.label_total_active_leads}}</h1>
        <div>
          <div class="flex-just">
            <h2>{{translation.label_affiliated_total_leads_ativos}}</h2>
            <h2>{{generalInfos.total_leads_pagos}}</h2>
          </div>
          <hr>
          <div class="flex-just">
            <h2>{{translation.label_2_tier_active_leads}}</h2>
            <h2>{{generalInfos.usuarios_2tier_pago}}</h2>
          </div>
        </div>
      </div>
    </div>
    <div class="card conversion">
      <h1>{{translation.conversion}}</h1>
      <h2 class="percentage">{{generalInfos.conversion}}%</h2>
    </div>
  </div>
</template>

<script>
// import merge from 'lodash-es/merge';

export default {
  name: "info-leads",
  components: {},
  data() {
    return {
      translation: this.$parent.$parent.view.translation.infoLeads,
      generalInfos: this.$parent.$parent.view.info_all_leads
    };
  },
  mounted() {
    // console.log(this.generalInfos);
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
* {
  color: #818a91;
}
h1 {
  font-size: 1.6rem;
  font-weight: bold;
  text-align: center;
}
h2 {
  font-size: 1.38rem;
  &:nth-child(2) {
    font-weight: bold;
  }
  &.percentage {
    font-size: 2.6rem;
    text-align: center;
    margin-top: 3rem;
    font-weight: unset;
  }
}
.flex-just {
  display: flex;
  justify-content: space-between;
}
.card {
  width: 45%;
  &.conversion {
    width: 100%;
  }
}
@media (max-width: 758px) {
  .flex-just.res {
    flex-direction: column;
  }
  .card {
    width: 100%;
  }
}
</style>


// WEBPACK FOOTER //
// resources/office/js/components/franchise/components/infoLeads.vue